/* eslint-disable quote-props */

import { ADMIN_ROLES } from "@teamprevent/common/auth/roles";

import { routes as immunisationRoutes } from "../../immunisations";
import { routes as clinicalHistory } from "../../clinicalHistory";
import { routes as healthSurveillanceRecallsRoutes } from "../../healthSurveillance/recalls/routes";
import { routes as occupationalIllnessRoutes } from "../../occupationalIllness";
import { routes as gpSpecialistInfoRoutes } from "../../generalPractitionerSpecialistInfo/routes";

import { AppState } from "./model";
import { employeeRecordSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";

const detailRoute = () => ({
    "/:employeeRecordId": {
        title: (state: AppState) => {
            const employee = employeeRecordSelector(state);
            return employee.firstName ? `${employee.firstName} ${employee.lastName} - ${employee.personalReferenceNumber}`
                : "Employee Record";
        },
        "/edit": {
            title: "Edit",
        },
        "/auditLog": {
            title: "Audit Log",
            authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        },
        ...detailRoutes,
        ...immunisationRoutes,
        ...occupationalIllnessRoutes,
        ...gpSpecialistInfoRoutes,
        ...clinicalHistory,
        ...healthSurveillanceRecallsRoutes
    }
});

export const routes = {
    "/employeeRecords": {
        ...detailRoute(),
        "/create": {
            title: "Create EmployeeRecord"
        }
    }
};

export const childRoutes =
    (titleFunc: (state: any) => string) => {
        return {
            "/employeeRecords": {
                title: (state: AppState) => titleFunc(state) ? titleFunc(state) + " Employee Records" : "Employee Records",
                ...detailRoute(),
                "/create": {
                    title: "Create Employee Record"
                }
            }
        };
    };
